import {createFeatureSelector, createSelector} from '@ngrx/store';
import {CanonicalId} from '@dcp/configurator';
import {DcpNetNewTermsConditions} from '@app/model/dcp-terms-and-conditions';
import {HttpErrorResponse} from '@angular/common/http';

export const termsAndConditionsFeatureKey = 'termsAndConditions';
export const TERMS_CONDITIONS_STATUS_LOADED = 'LOADED';

export interface TermsAndConditionsCanonicalIdMap {
  termsAndConditions: ReadonlyArray<DcpNetNewTermsConditions>;
  canonicalId: CanonicalId;
  loadStatus: 'LOADED' | 'LOADING' | 'NOT_LOADED' | 'ERROR';
  error?: HttpErrorResponse;
}

export interface TermsAndConditionsState {
  termsAndConditionsCanonicalIdMap: ReadonlyArray<TermsAndConditionsCanonicalIdMap>;
}

export const termsAndConditionsSelector = createFeatureSelector<TermsAndConditionsState>(termsAndConditionsFeatureKey);

const compareCanonicalId = (canonicalId1: CanonicalId, canonicalId2: CanonicalId) =>
  canonicalId1?.productId && canonicalId2?.productId
  && canonicalId1.productId.id === canonicalId2.productId.id
  && canonicalId1.productId.version === canonicalId2.productId.version
  && canonicalId1.productId.catalog === canonicalId2.productId.catalog
  && canonicalId1.entitlementRuleId === canonicalId2.entitlementRuleId;

const selectTermsAndConditionsState = createFeatureSelector<TermsAndConditionsState>(termsAndConditionsFeatureKey);

const selectAll = createSelector(
  selectTermsAndConditionsState,
  (state) => state?.termsAndConditionsCanonicalIdMap
);

const selectById = (canonicalId: CanonicalId) => createSelector(
  selectAll,
  (state: TermsAndConditionsCanonicalIdMap[]) => state.find((s) => compareCanonicalId(s.canonicalId, canonicalId))
);

export const fromTermsAndConditions = {
  selectAll,
  selectByCanonicalId: selectById,
  compareCanonicalId
};
